// Client-side slug parsing for the role-analysis screen. No network, no model.
// Fixed vocabulary of finance role terms, matched longest-first.
export const ROLE_KEYWORDS = [
  'group-financial-controller',
  'credit-risk-analyst',
  'finance-business-partner',
  'regulatory-reporting',
  'financial-controller',
  'finance-controller',
  'management-accountant',
  'financial-accountant',
  'financial-analyst',
  'group-accountant',
  'staff-accountant',
  'tax-accountant',
  'internal-auditor',
  'finance-manager',
  'finance-director',
  'credit-analyst',
  'group-controller',
  'accountant',
  'controller',
  'fp-a',
  'fpa',
].sort((a, b) => b.length - a.length)

// Keywords that ARE the library role rather than an adjacent one.
const LIBRARY_ROLE_KEYWORDS = [
  'group-financial-controller',
  'financial-controller',
  'finance-controller',
  'group-controller',
  'controller',
]

export function stripQuery(url: string) {
  return url.split('?')[0].split('#')[0]
}

const titleCase = (slug: string) =>
  slug
    .split(/[-_+\s]/)
    .filter(Boolean)
    .map((t) => (t === 'fpa' || t === 'fp' || t === 'a' ? t.toUpperCase() : t.charAt(0).toUpperCase() + t.slice(1)))
    .join(' ')

function matchKeyword(url: string) {
  const path = stripQuery(url).toLowerCase()
  const keyword = ROLE_KEYWORDS.find((k) => path.includes(k))
  return keyword ? { keyword, path } : null
}

export interface UrlSignal {
  matched: boolean
  token: string
}

export function readUrlSignal(url: string): UrlSignal {
  const match = matchKeyword(url)
  if (!match) return { matched: false, token: 'no role keyword in URL' }
  return { matched: true, token: `/${match.keyword}/` }
}

export interface RoleMatch {
  urlRole: string | null
  adjacent: boolean
}

export function readRoleMatch(url: string): RoleMatch {
  const match = matchKeyword(url)
  if (!match) return { urlRole: null, adjacent: false }
  return {
    urlRole: titleCase(match.keyword),
    adjacent: !LIBRARY_ROLE_KEYWORDS.includes(match.keyword),
  }
}
